import UnitsHelperUtil from './UnitsHelperUtil';
import Logger from './Logger';
import UtilsHelperClass from './UtilsHelper';

export const UnitsHelper = new UnitsHelperUtil();
export const UtilsHelper = new UtilsHelperClass();
export const LoggerService = Logger.getInstance();
